import { useScope } from "~/hooks/useScope";
import { OrganizationPolicyDetailPage } from "~/pages/organization/policy/OrganizationPolicyDetailPage";

export function OrganizationPolicyDetailEntryPage() {
  const { organizationScope } = useScope();
  return organizationScope ? (
    <OrganizationPolicyDetailPage scope={organizationScope} />
  ) : undefined;
}
